import { Link } from "@simplybusiness/mobius";

export type UnquotableProps = {
  contactPhoneNumber?: string;
  referenceNumber?: string;
};

export const Unquotable = ({
  contactPhoneNumber,
  referenceNumber,
}: UnquotableProps) => {
  return (
    <div className="mobius mobius-unquotable-card">
      <h2 className="mobius-unquotable-card__title">No quotes showing?</h2>
      <p className="mobius-unquotable-card__text">
        Our team will give you a call to see if we can put this right and find
        you a quote. If you&rsquo;d prefer to call us, we&rsquo;re here to help
        on{" "}
        <Link
          className="mobius-unquotable-card__contact-phone-number"
          href={`tel:${contactPhoneNumber}`}
        >
          {contactPhoneNumber}
        </Link>
        . Please have your reference number{" "}
        <strong className="mobius-unquotable-card__reference-number">
          {referenceNumber}
        </strong>{" "}
        to hand.
      </p>
    </div>
  );
};
